import {
  REQUEST as req,
  RESPONSE as res,
  FAILURE as fail,
  CLEAR as clr,
} from '../../actions/trainings/list';

const initialState = {
  response: {
    trainings: [],
    pagination: {
      total_pages: 0,
      total_items: 0,
      current_page: 0,
      per_page: 10
    }
  },
  isLoading: false,
  error: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case res:
      return {
        ...state,
        isLoading: false,
        response: action.payload,
        error: null
      };
    case fail:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case clr:
      return {
        ...state,
        response: initialState.response,
        isLoading: false,
        error: null
      };
    default:
      return state;
  }
};
